/**
 * FAKTURA „ZE ZAKÁZKY" — VYBER ZAKAZKY A DUVOD, PROC TO JESTE NEJDE
 * (krok UXP1, nalez P1-7 z rucniho pruchodu 10. 10. 2026).
 *
 * Pole „Zakázka" chtelo INTERNI UUID (napsane „Husova" skoncilo `400` a na
 * obrazovce se neukazalo nic) a tlacitko „Uložit koncept" bylo sede BEZ
 * VYSVETLENI. Oboji je tady jako cista funkce, aby to sla zmerit bez formulare
 * a aby duvod nemel druhou kopii v JSX.
 */
import { t } from '@reos/i18n';

const LOCALE = 'cs';

/** Kolik polozek napovedy se ukaze (tentyz strop jako nabidka zakazek u smluv). */
export const CASE_OPTIONS_LIMIT = 8;

/**
 * KDO PLATI PROVIZI: prodavajici nebo pronajimatel. Role jsou tytez kody, jake
 * zaklada pruvodce „Založit zakázku" (`lib/case-create.ts`) a jake pojmenovava
 * karta „Lidé" (`components/case-aside.tsx`).
 */
export const INVOICE_CLIENT_ROLES: readonly string[] = ['seller', 'landlord'];

export interface CaseParticipantLike {
  readonly partyId: string;
  readonly role: string;
}

/** Zakazky, jejichz jmeno obsahuje hledany text (bez ohledu na velikost pismen). */
export function matchingCases(
  index: ReadonlyMap<string, string>,
  query: string,
): readonly (readonly [string, string])[] {
  const needle = query.trim().toLowerCase();
  if (needle === '') return [];
  return [...index.entries()]
    .filter(([, name]) => name.toLowerCase().includes(needle))
    .slice(0, CASE_OPTIONS_LIMIT);
}

/**
 * Jediny mozny odberatel ze stran zakazky. Kdyz je prodavajicich vic, vybere
 * ho makler — domyslet jednoho z nich by znamenalo fakturovat nahodnemu.
 */
export function soleInvoiceParty(
  participants: readonly CaseParticipantLike[],
): CaseParticipantLike | null {
  const clients = participants.filter((p) => INVOICE_CLIENT_ROLES.includes(p.role));
  return clients.length === 1 ? (clients[0] ?? null) : null;
}

export interface CommissionBlockInput {
  readonly mode: 'free' | 'commission';
  readonly caseId: string;
  readonly caseContext: { readonly participants: readonly CaseParticipantLike[] } | null;
  readonly partyId: string | null;
}

/**
 * Proc „Uložit koncept" zatim nejde — veta pro cloveka, nebo `null` kdyz jde.
 * Poradi je poradi kroku ve formulari, aby hlaska rikala VZDY nejblizsi
 * chybejici vec, ne tu posledni.
 */
export function commissionBlockedReason(input: CommissionBlockInput): string | null {
  if (input.mode !== 'commission') return null;
  if (input.caseId.trim() === '') return t('webAdmin.fakturaceNova.blockedNoCase', { locale: LOCALE });
  if (input.caseContext === null) return t('webAdmin.fakturaceNova.blockedCaseNotLoaded', { locale: LOCALE });
  const hasClient = input.caseContext.participants.some((p) => INVOICE_CLIENT_ROLES.includes(p.role));
  if (!hasClient) return t('webAdmin.fakturaceNova.blockedNoSeller', { locale: LOCALE });
  if (input.partyId === null) return t('webAdmin.fakturaceNova.blockedNoCustomer', { locale: LOCALE });
  return null;
}
